import React, { useContext, useEffect, useRef, useState } from 'react';
import { Link, Navigate, Outlet } from 'react-router-dom';
import Swal from 'sweetalert2';
import { IdleTimerProvider } from 'react-idle-timer';

import NavBar from './componentes/NavBar';
import { Api } from './componentes/Api';
import { UserContext } from './context/UserProvider';

import 'react-toastify/dist/ReactToastify.css';

const App = () => {
    const { user, cerrarSession } = useContext(UserContext);
    const [VerContactos, setVerContactos] = useState(false);
    const [imageSrc, setImageSrc] = useState("");
    const [FechaL, setFechaL] = useState("");
    const logoutTimerRef = useRef(null);
    const licenciaExpiradaMostradaRef = useRef(false);
    const impresion = false;

    let currentUser = null;
    try {
        currentUser = user ? JSON.parse(user) : null;
    } catch {
        currentUser = null;
    }

    useEffect(() => {
        if (!currentUser?.idUsuario) {
            setFechaL("");
            return undefined;
        }

        let activo = true;

        const cargarEmpresa = async () => {
            try {
                const response = await fetch(Api + "Administracion/listaEmpresas/" + currentUser.idUsuario);
                if (!response.ok) {
                    return;
                }

                const data = await response.json();
                if (activo) {
                    setFechaL(data?.[0]?.fechaL || "");
                }
            } catch {
            }
        };

        cargarEmpresa();

        return () => {
            activo = false;
        };
    }, [currentUser?.idUsuario]);

    useEffect(() => {
        if (!currentUser?.idUsuario) {
            setImageSrc("");
            return undefined;
        }

        let activo = true;
        let objectUrl = "";

        const cargarImagen = async () => {
            try {
                const response = await fetch(Api + "Usuario/MostraFoto/" + currentUser.idUsuario);
                if (!response.ok) {
                    return;
                }

                const blob = await response.blob();
                objectUrl = URL.createObjectURL(blob);

                if (activo) {
                    setImageSrc(objectUrl);
                }
            } catch {
            }
        };

        cargarImagen();

        return () => {
            activo = false;
            if (objectUrl) {
                URL.revokeObjectURL(objectUrl);
            }
        };
    }, [currentUser?.idUsuario]);

    const mostrarModalSalir = () => {
        Swal.fire({
            title: 'Esta por salir',
            text: "Desea cerrar sesion?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, continuar',
            cancelButtonText: 'No, volver'
        }).then((result) => {
            if (result.isConfirmed) {
                cerrarSession();
            }
        });
    };

    const handleOnIdle = async () => {
        console.log('Usuario inactivo por 3 minutos');
    };

    const hoy = new Date();
    const vencimiento = FechaL ? new Date(FechaL) : null;
    const fechaLicenciaValida = vencimiento instanceof Date && !Number.isNaN(vencimiento.getTime());
    const diasRestantes = fechaLicenciaValida
        ? Math.ceil((vencimiento - hoy) / (1000 * 60 * 60 * 24))
        : null;

    useEffect(() => {
        if (logoutTimerRef.current) {
            clearTimeout(logoutTimerRef.current);
            logoutTimerRef.current = null;
        }

        if (diasRestantes == null || diasRestantes >= 0) {
            licenciaExpiradaMostradaRef.current = false;
            return undefined;
        }

        if (!licenciaExpiradaMostradaRef.current) {
            setVerContactos(true);
            licenciaExpiradaMostradaRef.current = true;
        }

        logoutTimerRef.current = setTimeout(() => {
            cerrarSession();
        }, 60000);

        return () => {
            if (logoutTimerRef.current) {
                clearTimeout(logoutTimerRef.current);
                logoutTimerRef.current = null;
            }
        };
    }, [diasRestantes, cerrarSession]);

    let clase = "alert alert-success";
    let mensaje = "";

    if (fechaLicenciaValida && diasRestantes != null) {
        mensaje = `Tu licencia vence el ${vencimiento.toLocaleDateString()} (${diasRestantes} dia(s) restantes).`;

        if (diasRestantes <= 14 && diasRestantes > 6) {
            clase = "alert alert-warning";
        } else if (diasRestantes <= 6 && diasRestantes > 0) {
            clase = "alert alert-danger";
        } else if (diasRestantes <= 0) {
            clase = "alert alert-danger";
            mensaje = `Tu licencia vencio el ${vencimiento.toLocaleDateString()}. Contacta soporte para renovarla. En 1 minuto se va a cerrar la seccion`;
        }
    }

    if (!currentUser) {
        return <Navigate to="/Login" />;
    }

    return (
        <IdleTimerProvider
            timeout={1000 * 60 * 1000}
            onIdle={handleOnIdle}
        >
            <>
                <NavBar data={impresion} />

                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
                            <button id="sidebarToggleTop" className="btn btn-link d-md-none rounded-circle mr-3">
                                <i className="fa fa-bars"></i>
                            </button>
                            {" . "} {localStorage.getItem("Empresa")}
                            <ul className="navbar-nav ml-auto">
                                <div className="topbar-divider d-none d-sm-block"></div>
                                <li className="nav-item dropdown no-arrow">
                                    <button
                                        type="button"
                                        className="nav-link dropdown-toggle"
                                        id="userDropdown"
                                        data-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                    >
                                        <span className="mr-2 d-none d-lg-inline text-gray-600 small">{currentUser.correo}</span>
                                        <img className="img-profile rounded-circle" src={imageSrc} alt="" />
                                    </button>
                                    <div
                                        className="dropdown-menu dropdown-menu-right shadow animated--grow-in"
                                        aria-labelledby="userDropdown"
                                    >
                                        <Link className="dropdown-item" to="/">
                                            <i className="fas fa-user fa-sm fa-fw mr-2 text-gray-400"></i>
                                            Perfil
                                        </Link>
                                        <div className="dropdown-divider"></div>
                                        <button className="dropdown-item" onClick={mostrarModalSalir}>
                                            <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
                                            Salir
                                        </button>
                                    </div>
                                </li>
                            </ul>
                        </nav>
                        <div className="container-fluid">
                            <Outlet />
                        </div>
                    </div>
                    <footer className="sticky-footer bg-white">
                        <div className="container my-auto">
                            <div className="copyright text-center my-auto">
                                <span>Copyright &copy; APATECH by 3S  2026  v.2.0.2 </span>
                                <img src="./imagen/logopie.svg" style={{ width: '5%' }} alt="" />
                                {(diasRestantes != null && diasRestantes <= 60 && mensaje) && (
                                    <div className={clase} onClick={() => setVerContactos(true)}>
                                        {mensaje}
                                    </div>
                                )}
                                <button hidden>
                                    <i className="fa fa-user">Soporte</i>
                                </button>
                            </div>
                        </div>
                    </footer>
                </div>

                {VerContactos && (
                    <div className="modal d-block" tabIndex="-1">
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header bg-warning">
                                    <h4 className="modal-title"><b>Información de licencia</b></h4>
                                    <button type="button" className="btn-close" onClick={() => setVerContactos(false)}></button>
                                </div>
                                <div className="modal-body">
                                    <p><strong>Tu licencia ha vencido o esta proxima a vencer.</strong></p>
                                    <p>Para renovarla, puedes comunicarte con nosotros o realizar tu pago por los siguientes medios:</p>
                                    <hr />
                                    <h5><b>Contacto:</b></h5>
                                    <ul>
                                        <li>Teléfono: <a href="tel:+18093023936" target="_blank" rel="noreferrer">+1 (809) 302-3936</a></li>
                                        <li>WhatsApp: <a href="https://wa.me/18093023936" target="_blank" rel="noreferrer">+1 (809) 302-3936</a></li>
                                        <li>Email: <a href="mailto:info@apatech.com.do">info@apatech.com.do</a></li>
                                    </ul>
                                    <h5><b>Opciones de pago:</b></h5>
                                    <ul>
                                        <li>Transferencia Bancaria: Banreservas, Banco BHD, Asociacion Popula y Banco Popular</li>
                                    </ul>
                                    <hr />
                                    {(diasRestantes != null && diasRestantes <= 60 && mensaje) && (
                                        <div className={clase} onClick={() => setVerContactos(true)}>
                                            {mensaje}
                                        </div>
                                    )}
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={() => setVerContactos(false)}>Cerrar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </>
        </IdleTimerProvider>
    );
};

export default App;
